import { render } from "./VerifyParentIdentity.vue?vue&type=template&id=56f470cd&scoped=true"
import script from "./VerifyParentIdentity.vue?vue&type=script&lang=js"
export * from "./VerifyParentIdentity.vue?vue&type=script&lang=js"

import "./VerifyParentIdentity.vue?vue&type=style&index=0&id=56f470cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f470cd"]])

export default __exports__